export function postFormData(url, formData) {
  return {
    method: "post",
    url,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  };
}
